import React, { Component } from "react";
import ReactGA from "react-ga";

import { Link, Redirect } from "react-router-dom";

import { connect } from "react-redux";

import Logo from "../assets/images/logo.png";
import Menu from "../assets/svg/menu-light.svg";
import Stars from "../assets/svg/4.5_stars.svg";

import { createStripe } from "../store/actions/authActions";

import MenuFunc from "./Menu";
import { Helmet } from "react-helmet";

import SVGLoader from "../assets/svg/loader.svg";

//import InjectedCheckoutForm from "./CheckoutForm";
//import InjectedCheckoutFormButtons from "./CheckoutFormButtons";

//import { loadStripe } from "@stripe/stripe-js";
//import { Elements } from "@stripe/react-stripe-js";

class Payment extends Component {
  state = {
    menuToggled: false,
    showform: false,
  };

  componentDidMount() {
    /*    if (!document.getElementById("stripe_script")) {
      var stripeScript = document.createElement("script");
      stripeScript.id = "stripe_script";
      stripeScript.type = "text/javascript";
      stripeScript.src = "https://js.stripe.com/v3/";
      document.body.appendChild(stripeScript);
    }
    */
  }

  setmenuoff = (wot) => {
    this.setState({ menuToggled: wot });
  };

  render() {
    const { auth, profile, geo } = this.props;
    if (JSON.parse(localStorage.getItem('isPremium')) === true) {
        profile.isPremium = true;
    }
    const price = geo === "NL" ? "4.99€" : geo === "GB" ? "£4.99" : "$4.99";
    if (!auth.uid)
      return (
        <Redirect
          to={{
            pathname: "/register",
            query: {
              fromUpgrade: true,
            },
          }}
        />
      );

    if (profile.isPremium)
      return (
        <Redirect
          to={{
            pathname: "/select-workout",
          }}
        />
      );

    return (
      <div>
        <Helmet>
          <title>S'inscrire à la version Premium</title>
          <meta
            name="description"
            content="BoxFit est l'application d'entraînement ultime à domicile
    avec plus de 390 exercices vidéo, 10 catégories d'entraînement différentes et premium,
    des fonctionnalités telles que l'historique d'entraînement et le radar de poids."
          />

          <meta property="og:url" content="https://www.boxfit-fitness.com/upgrade" />
          <meta property="og:title" content="BoxFit" />
          <meta
            property="og:description"
            content="BoxFit est l'application d'entraînement ultime à domicile
    avec plus de 390 exercices vidéo, 10 catégories d'entraînement différentes et premium,
    des fonctionnalités telles que l'historique d'entraînement et le radar de poids."
          />
          <meta property="og:site_name" content="BoxFit" />
          <meta
            property="og:image"
            content="https://www.boxfit-fitness.com/images/sharer.png"
          />
          <meta property="og:type" content="profile" />
          <meta property="og:locale" content="en_US" />
        </Helmet>
        <div style={{ position: "relative" }}>
          <MenuFunc display={this.state.menuToggled} off={this.setmenuoff} />

          <div
            style={{
              zIndex: 999,
              position: "absolute",
              top: "15px",
              left: "20px",
            }}
          >
            <Link
              to={{
                pathname: "/",
                query: {
                  fromMenu: true,
                },
              }}
            >
              <img src={Logo} alt="logo" style={{ maxHeight: "45px" }}></img>
            </Link>
          </div>

          <div
            style={{
              position: "absolute",
              top: "25px",
              right: "22px",
              zIndex: 999,
            }}
            onClick={() => {
              this.setmenuoff(true);
            }}
          >
            <img src={Menu} alt="logo" style={{ maxHeight: "25px" }}></img>
          </div>
        </div>

        <div className="Screen">
          <div>
            <div style={{ height: "60px" }}></div>
            <div style={{ padding: "0px 20px 20px 20px" }}>
              {profile.startedtrial ? (
                <h2
                  style={{
                    fontSize: "28px",
                    color: "#69C9D0",
                    borderRadius: "2px",
                  }}
                >
                  Souscrire à BoxFit Premium
                </h2>
              ) : (
                <h2
                  style={{
                    fontSize: "28px",
                    color: "#69C9D0",
                    borderRadius: "2px",
                  }}
                >
                  Essayez la version premium gratuitement
                </h2>
              )}

              <h2
                style={{
                  fontSize: "20px",
                }}
              >
                {profile.startedtrial
                  ? "Essayez Boxfit pour juste " + price + "/mois et profitez:"
                  : "D'un essai gratuit de 7 jours et ensuite pour seulement " +
                    price +
                    "/mois profitez de:"}
              </h2>

              <ul className="listaupgrade" style={{ padding: "0px 20px" }}>
                <li>Plus de 390 nouveaux exercices</li>
                <li>10 catégories d'entraînement</li>
                <li>Historique d'entraînement & Radar de poids</li>
                <li>Support 24/7</li>
                <li>Nouveaux Exercices chaque mois</li>
                <li>Désinscription quand vous voulez</li>
              </ul>

              <div style={{ height: "10px" }}></div>

              {this.state.showform ? (
                <button
                  style={{
                    fontSize: "18px",
                    background: "#EE1D52",
                    padding: "10px",
                    border: 0,
                    borderRadius: "4px",
                    fontWeight: "600",
                    width: "100%",
                    color: "white",
                  }}
                  disabled
                >
                  <img
                    src={SVGLoader}
                    style={{ maxWidth: "30px" }}
                    alt="loading"
                  />
                </button>
              ) : (
                <button
                  style={{
                    fontSize: "18px",
                    background: "#EE1D52",
                    padding: "10px",
                    border: 0,
                    borderRadius: "4px",
                    fontWeight: "600",
                    width: "100%",
                    color: "white",
                  }}
                  onClick={() => {
                    ReactGA.event({
                      category: "User",
                      action: "Clicked Free Trial",
                    });
                    this.setState({ showform: true });
                    this.props.createStripe({
                      id: auth.uid,
                      email: profile.email,
                      geo: geo,
                      startedtrial: profile.startedtrial || null,
                    });
                  }}
                >
                  <span role="img" aria-label="like">
                    👉
                  </span>{" "}
                  {profile.startedtrial ? "Version Premium" : "Essai gratuit"}
                </button>
              )}

              <p
                style={{
                  fontSize: "18px",
                  textAlign: "center",
                }}
              >
                <img src={Stars} alt="reviews" style={{ height: "15px" }} />{" "}
                Rejoignez plus de <strong>2300</strong> heureux athlètes
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  if (JSON.parse(localStorage.getItem('isPremium')) === true) {
    state.firebase.profile.isPremium = true;
  }
  return {
    auth: state.firebase.auth,
    profile: state.firebase.profile,
    geo: state.auth.geo,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    createStripe: (creds) => dispatch(createStripe(creds)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Payment);
